import { findKey } from 'lodash';
import React from 'react';
import { all, call, put, retry } from 'redux-saga/effects';

import qs from 'qs';

import { toast } from 'react-toastify';

import { Creators as ListaActions } from '../ducks/lista';

import { listasAPI, listasMassaInicialAPI } from '../../services/api';

import { getBase64 } from '../../utils/array';
import {
  responseHandler,
  responseHandlerGet,
} from '../../utils/responseHandler';

import history from '../../services/history';

import {
  ErrorToast,
  SuccessToast,
  WarningToast,
} from '../../components/molecules/Toast';

import { StatusListaAPIEnum, StatusListaRPAEnum } from '../../enums';

export function* deleteListaCsv(action) {
  try {
    const { params } = action.payload;
    const listas = params.filter((file) => file.nomeLista);
    yield all(
      listas.map((lista) =>
        call(listasAPI.delete, `/delete-csv/${lista.nomeLista}`)
      )
    );
  } catch (error) {
    toast.success(<ErrorToast size="30">Erro ao Excluir Lista.</ErrorToast>);
  }
}
export function* getDownloadArquivoOriginalLote(action) {
  const { params } = action.payload;
  try {
    const response = yield call(listasAPI.get, `/download-csv/${params}`);
    const isSuccess = response.status === 200 || false;

    if (response.status === 204) {
      toast.error(
        <WarningToast>
          Não foram encontrados dados para o download.
        </WarningToast>
      );
    }
    yield put(
      ListaActions.getDownloadArquivoLoteOriginalSuccess(
        response.data,
        isSuccess
      )
    );
    yield put(ListaActions.getDownloadArquivoLoteOriginalRenew());
  } catch (error) {
    yield put(ListaActions.getDownloadArquivoLoteOriginalError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postRelatorioResumidoNovo(action) {
  const { params, tipoRelatorio } = action.payload;

  try {
    const response = yield call(
      listasAPI.post,
      `/relatorio-resumido-novo`,
      params
    );

    const isSuccess = response.status === 200 || false;

    if (response.status === 204) {
      toast.error(
        <WarningToast>
          Não foram encontrados dados para o download do arquivo excel.
        </WarningToast>
      );
    }

    yield put(
      ListaActions.postRelatorioResumidoNovoSuccess(response.data, isSuccess)
    );
    yield put(ListaActions.postRelatorioResumidoNovoRenew());
  } catch (error) {
    yield put(ListaActions.postRelatorioResumidoNovoError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postRelatorioDetalhadoNovo(action) {
  const { params, tipoRelatorio } = action.payload;

  try {
    const response = yield call(
      listasAPI.post,
      `/relatorio-detalhado-novo`,
      params
    );

    const isSuccess = response.status === 200 || false;

    if (response.status === 204) {
      toast.error(
        <WarningToast>
          Não foram encontrados dados para o download do arquivo excel.
        </WarningToast>
      );
    }

    yield put(
      ListaActions.postRelatorioDetalhadoNovoSuccess(response.data, isSuccess)
    );
    yield put(ListaActions.postRelatorioDetalhadoNovoRenew());
  } catch (error) {
    yield put(ListaActions.postRelatorioDetalhadoNovoError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postSearchListRpa(action) {
  const { params } = action.payload;

  try {
    const response = yield call(listasAPI.post, `/search-rpa`, params);
    if (response.status === 200) {
      const idsListas = response.data.data.map((lista) => lista.idLista);

      let listasSinalizadas;

      if (idsListas.length > 0) {
        listasSinalizadas = yield call(
          listasAPI.post,
          `/lista-sinalizacao-rn412`,
          {
            ids_lista: idsListas,
          }
        );
      }

      const listas = response.data.data.map((lista) => {
        const listaSinalizada = listasSinalizadas.data.find(
          (item) => item.idLista === lista.idLista
        );
        if (listaSinalizada) {
          return {
            ...lista,
            ...listaSinalizada,
          };
        }
        return lista;
      });

      const data = { ...response.data, data: listas };

      yield put(ListaActions.postSearchListRpaResponse(data, true));
    }
  } catch (error) {
    toast.error(<ErrorToast>Não foi Possível buscar listas RPA.</ErrorToast>);
  }
}

export function* getStatusListRpa() {
  const data = yield call(listasAPI.get, `/status-rpa`);
  if (data.status === 200) {
    const allCount = data.data.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      0
    );

    const response = {
      availables: [
        { id: 0, description: 'Todos', count: allCount },
        ...data.data,
      ],
      actives: [],
    };

    yield put(ListaActions.getStatusListRpaResponse(response, true));
  }
}
export function* postSearchList(action) {
  const { params } = action.payload;

  try {
    const response = yield call(listasAPI.post, `/search-list`, params);

    if (response.status === 200) {
      const idsListas = response.data.data.map((lista) => lista.idLista);

      let listasSinalizadas;

      if (idsListas.length > 0) {
        listasSinalizadas = yield call(
          listasAPI.post,
          `/lista-sinalizacao-rn412`,
          {
            ids_lista: idsListas,
          }
        );
      }

      const listas = response.data.data.map((lista) => {
        const listaSinalizada = listasSinalizadas.data.find(
          (item) => item.idLista === lista.idLista
        );
        if (listaSinalizada) {
          return {
            ...lista,
            ...listaSinalizada,
          };
        }
        return lista;
      });

      const data = { ...response.data, data: listas };
      yield put(ListaActions.postSearchListResponse(data, true));
    }
  } catch (error) {
    toast.error(<ErrorToast>Não foi Possível buscar listas.</ErrorToast>);
  }
}

export function* getStatusListContratante(action) {
  const data = yield call(
    listasAPI.get,
    `/status-list/contractor-code/${parseInt(
      action.payload.idContrantante
    )}?withFakeList=${action.payload.mostrarListaFake}`
  );

  if (data.status === 200) {
    const allCount = data.data.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      0
    );
    const response = {
      availables: [
        { id: 0, description: 'Todos', count: allCount },
        ...data.data,
      ],
      actives: [],
    };
    yield put(ListaActions.getStatusListContratanteResponse(response, true));
  }
}
export function* getStatusListNestle(action) {
  const data = yield call(
    listasAPI.get,
    `/status-list/nestle?withFakeList=${action.payload.mostrarListaFake}`
  );
  if (data.status === 200) {
    const allCount = data.data.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      0
    );

    const response = {
      availables: [
        { id: 0, description: 'Todos', count: allCount },
        ...data.data,
      ],
      actives: [],
    };

    yield put(ListaActions.getStatusListNestleResponse(response, true));
  }
}

export function* getStatusListAdmin(action) {
  const data = yield call(listasAPI.get, `/status-list`);
  if (data.status === 200) {
    const allCount = data.data.reduce(
      (accumulator, currentValue) => accumulator + currentValue.count,
      0
    );

    const response = {
      availables: [
        { id: 0, description: 'Todos', count: allCount },
        ...data.data,
      ],
      actives: [],
    };

    yield put(ListaActions.getStatusListAdminResponse(response, true));
  }
}
export function* getListas(action) {
  const { TipoStatus } = action.payload;

  const { tipoStatus, totalPages, ...queryParams } = action.payload.params;

  try {
    const response = yield all(
      Object.values(TipoStatus).map(function* (status) {
        const queryString = {
          ...queryParams,
          ...(status !== StatusListaAPIEnum.returnNameForTab.Todas && {
            idStatus: status,
          }),
        };

        const params = qs.stringify(queryString, {
          addQueryPrefix: true,
          skipNulls: true,
          arrayFormat: 'repeat',
        });

        const objResponse = yield retry(1, 2000, listasAPI.get, '', {
          params: queryString,
        });

        objResponse.data.status = findKey(TipoStatus, (o) => o === status);
        return objResponse;
      })
    );

    const { isSuccess } = responseHandler(
      response,
      action.payload,
      'data',
      'getListas',
      200
    );

    const listas = response.map((resp) => resp.data);
    const dataLista = {
      response: listas,
      isSuccess,
    };
    yield put(
      ListaActions.getListasSuccess(dataLista.response, response.isSuccess)
    );
  } catch (error) {
    yield put(ListaActions.getListasError(error));
  }
}

export function* postListaInativas(action) {
  const { contratante } = action.payload;

  const request = yield {
    contratante: contratante.codigoContratante,
    solicitante: contratante.idUsuarioLogado,
  };

  try {
    const { data } = yield call(listasAPI.post, '/lista-inativos', request);

    if (data.success) {
      yield put(ListaActions.postListaInativasSuccess(data.data, true));
    }
  } catch (error) {
    toast.error(<ErrorToast>Não foi possível criar lista.</ErrorToast>);
  }
}

export function* getListaInativas(action) {
  const { data } = yield call(
    listasAPI.get,
    `lista-inativos/${action.payload.idLista}`
  );
  if (data.success) {
    yield put(ListaActions.getListaInativasSuccess(data.data, true));
  }
}

export function* putListaInativas(action) {
  const request = yield {
    idLista: action.payload.params.idLista,
    modalidade: action.payload.params.modalidade,
    descricao: action.payload.params.descricao,
  };

  const { data } = yield call(listasAPI.put, 'lista-inativos/', request);
  if (data.success) {
    yield put(ListaActions.putListaInativasSuccess(data.data, true));
  }
}

export function* getListaBeneficiario(action) {
  const params = {
    pageNumber: action.payload.params.pageNumber || 1,
    pageSize: action.payload.params.pageSize || 10,
  };
  const request = {
    ...action.payload.params,
  };
  const { data } = yield call(
    listasAPI.post,
    `lista-inativos/${action.payload.params.idLista}/pesquisa-beneficiario`,
    request,
    { params }
  );
  if (data.success) {
    yield put(ListaActions.getListaBeneficiarioSuccess(data, true));
  }
}

export function* postSalvarBeneficiarioInativos(action) {
  const { params: request } = action.payload;
  const { idLista } = request;

  try {
    const { data } = yield call(
      listasAPI.post,
      `lista-inativos/${idLista}/salvar-beneficiario`,
      request
    );

    if (data.success) {
      yield put(
        ListaActions.postSalvarBeneficiarioInativosSuccess(data.data, true)
      );
      return;
    }

    throw new Error(data.message || 'Erro ao salvar beneficiario.');
  } catch (error) {
    toast.error(<ErrorToast size="30">{error.message}</ErrorToast>);
    yield put(ListaActions.postSalvarBeneficiarioInativosError(error));
  }
}

export function* postFamiliar(action) {
  const { idLista, beneficiarios } = action.payload;

  try {
    const { data } = yield call(
      listasAPI.post,
      `lista-inativos/${idLista}/salvar-familiar`,
      beneficiarios
    );

    if (data.success)
      yield put(ListaActions.postFamiliarResponse(data.data, data.success));
    else
      yield put(
        ListaActions.postFamiliarResponse(
          {},
          data.success,
          'Erro ao atualizar beneficiários'
        )
      );
  } catch (error) {
    yield put(ListaActions.postFamiliarResponse({}, false, error));
  }
}

export function* getListaGrupoFamiliar(action) {
  const { data } = yield call(
    listasAPI.get,
    `lista-inativos/${action.payload.id}/grupo-familiar`
  );

  if (data.success) {
    yield put(ListaActions.getListaGrupoFamiliarSuccess(data.data, true));
  }
}

export function* getListaPorStatus(action) {
  const { tipoStatus, totalPages, ...queryParams } = action.payload.params;
  const queryString = {
    ...queryParams,
    ...(tipoStatus !== StatusListaAPIEnum.returnNameForTab.Todas && {
      idStatus: tipoStatus,
    }),
  };

  try {
    const response = yield retry(10, 2000, listasAPI.get, '', {
      params: queryString,
    });

    response.data.status = findKey(
      StatusListaAPIEnum.returnNameForTab,
      (o) => o === tipoStatus
    );
    // response.data.status = tipoStatus;

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getListaPorStatus',
      200
    );

    const dataUsuarios = {
      response: response.data,
      isSuccess,
    };

    yield put(
      ListaActions.getListasPorStatusSuccess(
        dataUsuarios.response,
        dataUsuarios.isSuccess
      )
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getListaPorStatus',
      200
    );

    yield put(ListaActions.getListasPorStatusError(unsuccessResponse));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de usuários.
      </ErrorToast>
    );
  }
}

export function* postArquivoImportacao(action) {
  const { novoArquivoRequest } = action.payload;

  const body = {
    idLista: novoArquivoRequest[0].idLista,
    arquivo: novoArquivoRequest[0].base64,
    nomeArquivo: novoArquivoRequest[0].name,
    idHub: null,
  };

  try {
    const response = yield call(listasAPI.post, `/arquivo-importacao`, body);

    const isSuccess = response.status > 199 && response.status < 299;
    if (isSuccess) {
      yield put(
        ListaActions.postArquivoImportacaoSuccess(novoArquivoRequest[0])
      );
      toast.success(
        <SuccessToast size="30">Arquivo(s) alterado com sucesso.</SuccessToast>
      );
    } else throw new Error('Erro ao alterar arquivo.');
  } catch (error) {
    yield put(ListaActions.postArquivoImportacaoError(error));
    toast.error(
      <ErrorToast size="30">
        Erro ao importar o arquivo:
        <br />
        <strong>{novoArquivoRequest.nomeArquivo}</strong>.
        <br />
        {error.response.data.errors.Messages}.
      </ErrorToast>
    );
  }
}

export function* validarLoteCsv(action) {
  const { params } = action.payload;

  const isLoteSuccess = [];
  try {
    yield* params.newFiles.map(function* (file) {
      let isSuccess = false;
      try {
        const fileToBase64 = yield getBase64(file.file);

        const fileListaRequest = {
          nome_arquivo: file.name,
          arquivo: fileToBase64,
          codigo_contratante: params?.codigoContratante,
        };

        const response = yield retry(
          1,
          2000,
          listasAPI.post,
          `/upload-csv`,
          fileListaRequest
        );

        const { idLista, TipoMovimentacao, codigoContratante, ...newFile } =
          file;

        yield retry(
          1,
          2000,
          listasAPI.post,
          `/validation-progress/${response.data.nomeLista}/${params?.idUsuarioLogado}`
        );

        newFile.idLista = response.data.idLista;
        newFile.codigoContratante = params?.codigoContratante;
        newFile.nomeLista = response.data.nomeLista;
        newFile.progress = 100;

        isSuccess = response.status > 199 && response.status < 300;
        isLoteSuccess.push(isSuccess);

        yield put(ListaActions.importarLoteUpdate(newFile));
        yield put(
          ListaActions.importarLoteUpdateStatus(newFile.idFile, false, true)
        );
      } catch (err) {
        isLoteSuccess.push(isSuccess);

        if (err.response.status === 403) {
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
              <br />
              {err.response.data.message}
            </ErrorToast>
          );
        }
        if (err.response.status === 400) {
          if (
            err.response.data.log_errors &&
            err.response.data.status_progress === 2
          ) {
            toast.error(
              <ErrorToast size="30">
                A lista foi criada com sucesso, porém existem inconsistências
                retornadas pelo progress, verifique o log de erros.
                <br />
                <strong>{file.name}</strong>.
                <br />
              </ErrorToast>
            );
          }
          yield put(
            ListaActions.importarLoteLogError(
              file.name,
              err.response.data.erros_base64 || err.response.data.log_errors
            )
          );
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
            </ErrorToast>
          );
        } else {
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
              <br />
              {err.response.data.errors.Messages}
            </ErrorToast>
          );
        }
        yield put(
          ListaActions.importarLoteUpdateStatus(file.idFile, true, false)
        );
      }
    });

    const isSuccess = isLoteSuccess.every((resp) => !!resp);
    const isPartialSuccess = isSuccess
      ? false
      : isLoteSuccess.some((resp) => !!resp);
    const isError = isLoteSuccess.every((resp) => !resp);
    if ((isSuccess || isPartialSuccess) && !isError) {
      yield put(ListaActions.importarLoteSuccess(isSuccess, isPartialSuccess));

      if (isSuccess)
        toast.success(
          <SuccessToast size="30">
            Arquivo(s) Validado(s) com sucesso.
          </SuccessToast>
        );
      if (isPartialSuccess)
        toast.success(
          <WarningToast size="30">
            Somente os arquivos com sucesso serão importados.
          </WarningToast>
        );
    } else {
      yield put(
        ListaActions.importarLoteError(
          'Erro ao carregar o lote atual.',
          isError
        )
      );
    }
  } catch (error) {
    yield put(ListaActions.importarLoteError(error, true));
  }
}
export function* importarLoteCsv(action) {
  const { params } = action.payload;

  const isLoteSuccess = [];
  try {
    yield* params.newFiles.map(function* (file) {
      let isSuccess = false;
      try {
        const fileListaRequest = {
          arquivo: file,
          codigo_contratante: params?.codigoContratante,
          id_usuario_solicitante: params?.idUsuarioLogado,
          criar_lista: true,
        };

        const response = yield retry(
          1,
          2000,
          listasAPI.post,
          `/upload-csv`,
          fileListaRequest
        );

        isSuccess = response.status > 199 && response.status < 300;
        isLoteSuccess.push(isSuccess);

        if (isLoteSuccess.length === params.newFiles.length) {
          toast.success(
            <SuccessToast size="30">
              Arquivo(s) Importado(s) com sucesso.
            </SuccessToast>
          );
          yield put(ListaActions.importarLoteCsvSuccess(true));
          setTimeout(() => history.go(0), 1500);
        }
      } catch (err) {
        toast.error(
          <ErrorToast size="30">
            Erro ao Importar arquivo:
            <br />
            {err.response.data.message}
          </ErrorToast>
        );
      }
    });
  } catch (error) {
    toast.error(
      <ErrorToast size="30">
        Erro ao Importar arquivo:
        <br />
        {error.response.data.message}
      </ErrorToast>
    );
  }
}
export function* importarLote(action) {
  const { params } = action.payload;

  const newLista = yield {
    cdContratante: params?.codigoContratante,
    tipoLista: params?.TipoLista,
  };
  const isLoteSuccess = [];
  try {
    yield* params.newFiles.map(function* (file) {
      let isSuccess = false;
      try {
        const { data } = yield retry(1, 2000, listasAPI.post, ``, newLista);

        const fileToBase64 = yield getBase64(file.file);
        const { idLista, TipoMovimentacao, codigoContratante, ...newFile } =
          file;

        newFile.idLista = data.idLista;
        newFile.codigoContratante = params?.codigoContratante;
        newFile.nomeLista = data.nmLista;

        yield put(ListaActions.importarLoteUpdate(newFile));

        const fileListaRequest = {
          idLista: data.idLista,
          arquivo: fileToBase64,
          nomeArquivo: file.name,
          idHub: params.connection.connectionId,
        };
        const response = yield retry(
          1,
          2000,
          listasAPI.post,
          `/arquivo-importacao`,
          fileListaRequest
        );

        isSuccess = response.status > 199 && response.status < 300;

        isLoteSuccess.push(isSuccess);

        yield put(
          ListaActions.importarLoteUpdateStatus(newFile.idFile, false, true)
        );
      } catch (err) {
        isLoteSuccess.push(isSuccess);
        if (err.response.status === 403) {
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
              <br />
              {err.response.data.message}
            </ErrorToast>
          );
        }
        if (err.response.status === 400) {
          yield put(
            ListaActions.importarLoteLogError(
              file.name,
              err.response.data && err.response.data.errors.Messages
            )
          );
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
            </ErrorToast>
          );
        } else {
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
              <br />
              {err.response.data.errors.Messages}
            </ErrorToast>
          );
        }
        yield put(
          ListaActions.importarLoteUpdateStatus(file.idFile, true, false)
        );
      }
    });

    const isSuccess = isLoteSuccess.every((resp) => !!resp);
    const isPartialSuccess = isSuccess
      ? false
      : isLoteSuccess.some((resp) => !!resp);
    const isError = isLoteSuccess.every((resp) => !resp);
    if ((isSuccess || isPartialSuccess) && !isError) {
      yield put(ListaActions.importarLoteSuccess(isSuccess, isPartialSuccess));

      if (isSuccess)
        toast.success(
          <SuccessToast size="30">
            Arquivo(s) carregado(s) com sucesso.
          </SuccessToast>
        );
      if (isPartialSuccess)
        toast.success(
          <WarningToast size="30">
            Somente os arquivos com sucesso serão importados.
          </WarningToast>
        );
    } else {
      yield put(
        ListaActions.importarLoteError(
          'Erro ao carregar o lote atual.',
          isError
        )
      );
    }
  } catch (error) {
    console.log(error);
    yield put(ListaActions.importarLoteError(error, true));
  }
}

export function* putListas(action) {
  try {
    const { listas } = action.payload;
    const response = yield all(
      listas.map((lista) =>
        call(listasAPI.put, ``, {
          idLista: lista.idLista,
          idStatusLista: StatusListaAPIEnum.returnId.Registrada,
          dcDescricao: lista.descricao,
        })
      )
    );
    const isSuccess = response.every(
      (resp) => resp.status > 199 && resp.status < 300
    );
    if (isSuccess) {
      yield put(ListaActions.putListasSuccess(listas, isSuccess));
      toast.success(
        <SuccessToast size="30">
          Sucesso ao alterar a(s) informações!
        </SuccessToast>
      );
    } else throw new Error('Erro ao salvar informações');
  } catch (error) {
    yield put(ListaActions.putListasError(error));
    toast.error(
      <ErrorToast size="30">Erro ao alterar a(s) informações!</ErrorToast>
    );
  }
}

export function* patchListaStatus(action) {
  try {
    const { listas } = action.payload;

    const response = yield all(
      listas.map((lista) => call(listasAPI.patch, `Status`, lista))
    );

    const isSuccess = response.every(
      (resp) => resp.status > 199 && resp.status < 300
    );
    if (isSuccess) {
      yield put(ListaActions.patchListaStatusSuccess(isSuccess));
      toast.success(
        <SuccessToast size="30">
          Sucesso ao alterar o status da lista!
        </SuccessToast>
      );
      yield put(ListaActions.deleteListaRenew());
      yield put(ListaActions.putListasRenew());
      yield put(ListaActions.patchListaStatusRenew());
      history.push('/novo/lista');
    } else throw new Error('Erro ao alterar o status');
  } catch (error) {
    yield put(ListaActions.patchListaStatusError(error));
    toast.error(
      <ErrorToast size="30">Erro ao alterar o status da lista!</ErrorToast>
    );
  }
}

export function* deleteLista(action) {
  try {
    const { listas } = action.payload;

    const listasComIdLista = listas.filter(
      (file) => file.idLista !== null && file.idLista !== undefined
    );

    const response = yield all(
      listasComIdLista.map((lista) =>
        call(listasAPI.delete, `/${lista.idLista}`)
      )
    );
    const isSuccess = response.every(
      (resp) => resp.status > 199 && resp.status < 300
    );
    if (isSuccess) {
      yield put(ListaActions.deleteListaSuccess(isSuccess, listas));
      toast.success(
        <SuccessToast size="30">Lista(s) removida(s) com sucesso.</SuccessToast>
      );
    } else
      yield put(ListaActions.deleteListaError('Erro ao deletar as listas.'));
  } catch (error) {
    yield put(ListaActions.deleteListaError(error));
  }
}

export function* patchListaEnvioRPA(action) {
  try {
    const { listas, isActive } = action.payload;

    const response = yield all(
      listas.map((lista) =>
        retry(2, 2000, listasAPI.patch, `${lista.idLista}/enviar-rpa`, {
          ativo: isActive,
        })
      )
    );

    const { unsuccessResponse, isSuccess } = responseHandler(
      response,
      listas,
      'idLista',
      'patchListaEnvioRPA',
      204
    );

    yield put(
      ListaActions.patchListaEnvioRPASuccess(unsuccessResponse, isSuccess)
    );
  } catch (error) {
    yield put(ListaActions.patchListaEnvioRPAError(error));
  }
}

export function* getListasRPA(action) {
  const { TipoStatus } = action.payload;

  const { tipoStatus, totalPages, ...queryParams } = action.payload.params;

  try {
    const response = yield all(
      Object.values(TipoStatus).map(function* (status) {
        const queryString = {
          ...queryParams,
          ...{
            idStatusRpa:
              status !== StatusListaRPAEnum.returnNameForTab.Todas
                ? status
                : null,
            idStatus: 10,
            statusEnvioRpa: true,
          },
        };

        const objResponse = yield retry(1, 2000, listasAPI.get, '', {
          params: queryString,
        });
        objResponse.data.status = findKey(TipoStatus, (o) => o === status);
        return objResponse;
      })
    );

    const { isSuccess } = responseHandler(
      response,
      action.payload,
      'data',
      'getListasRPA',
      200
    );

    const listas = response.map((resp) => resp.data);

    const dataLista = {
      response: listas,
      isSuccess,
    };
    yield put(
      ListaActions.getListasRPASuccess(dataLista.response, response.isSuccess)
    );
  } catch (error) {
    console.log(error);
    yield put(ListaActions.getListasRPAError(error));
  }
}

export function* getListaPorStatusRPA(action) {
  const { tipoStatus, totalPages, ...queryParams } = action.payload.params;
  const queryString = {
    ...queryParams,
    ...{
      idStatusRpa:
        tipoStatus !== StatusListaRPAEnum.returnNameForTab.Todas
          ? tipoStatus
          : null,
      idStatus: 10,
      statusEnvioRpa: true,
    },
  };

  try {
    const response = yield retry(10, 2000, listasAPI.get, '', {
      params: queryString,
    });

    response.data.status = findKey(
      StatusListaRPAEnum.returnNameForTab,
      (o) => o === tipoStatus
    );
    // response.data.status = tipoStatus;

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'getListaPorStatusRPA',
      200
    );

    const dataUsuarios = {
      response: response.data,
      isSuccess,
    };

    yield put(
      ListaActions.getListasRPAPorStatusSuccess(
        dataUsuarios.response,
        dataUsuarios.isSuccess
      )
    );
  } catch (error) {
    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.data,
      'getListaPorStatusRPA',
      200
    );

    yield put(ListaActions.getListasRPAPorStatusError(unsuccessResponse));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para consulta de listas.
      </ErrorToast>
    );
  }
}

export function* patchStatusRPA(action) {
  try {
    const { listas, tipoStatus } = action.payload;

    const response = yield all(
      listas.map((lista) =>
        retry(2, 2000, listasAPI.patch, `${lista.idLista}/status-rpa`, {
          idStatus: tipoStatus,
        })
      )
    );

    const { unsuccessResponse, isSuccess } = responseHandler(
      response,
      listas,
      'idLista',
      'patchStatusRPA',
      204
    );

    yield put(ListaActions.patchStatusRPASuccess(unsuccessResponse, isSuccess));
  } catch (error) {
    yield put(ListaActions.patchStatusRPAError(error));
  }
}

export function* getRelatorioRPA(action) {
  const { params, tipoRelatorio } = action.payload;

  const queryString = {
    ...params,
    idStatus: 10,
    statusEnvioRpa: true,
  };

  try {
    const response = yield retry(
      5,
      2000,
      listasAPI.get,
      `/relatorio-${tipoRelatorio}`,
      { params: queryString }
    );

    const isSuccess = response.status === 200 || false;

    if (response.status === 204) {
      toast.error(
        <WarningToast>
          Não foram encontrados dados para o download do arquivo excel.
        </WarningToast>
      );
    }

    yield put(ListaActions.getRelatorioRPASuccess(response.data, isSuccess));
    yield put(ListaActions.getRelatorioRPARenew());
  } catch (error) {
    yield put(ListaActions.getRelatorioRPAError(error));
  }
}

export function* getListaDetalhe(action) {
  const { idLista } = action.payload;
  try {
    const response = yield retry(2, 2000, listasAPI.get, `/${idLista}`);

    const isSuccess = response.status === 200 || false;

    yield put(ListaActions.getListaDetalheSuccess(response.data, isSuccess));
  } catch (error) {
    yield put(ListaActions.getListaDetalheSuccess(error));
  }
}
export function* getListaMassaInicial(action) {
  try {
    const { params } = action.payload;

    const objResponse = yield retry(1, 2000, listasAPI.get, `/massa-inicial`, {
      params,
    });

    const success = objResponse.status > 199 && objResponse.status < 300;

    if (success) {
      yield put(ListaActions.getListasMassaInicialSuccess(objResponse.data));
    }
  } catch (error) {
    yield put(ListaActions.patchStatusRPAError(error));
  }
}

export function* getArquivoMassaInicial(action) {
  const { idLista, idArquivo, nomeArquivoDownload } = action.payload;

  try {
    const response = yield retry(
      5,
      2000,
      listasAPI.get,
      `/${idLista}/arquivo-massa-inicial`,
      { params: { idArquivo } }
    );

    const success = response.status > 199 && response.status < 300;

    if (success) {
      yield put(
        ListaActions.getArquivoMassaInicialSuccess(
          response.data,
          nomeArquivoDownload
        )
      );
    }
  } catch (error) {
    yield put(ListaActions.getArquivoMassaInicialError(error));
  }
}

export function* getTermoResponsabilidadeMassaInicial(action) {
  const { idLista, nomeArquivoDownload } = action.payload;

  try {
    const response = yield retry(
      5,
      2000,
      listasAPI.get,
      `/${idLista}/arquivo-termo-responsabilidade`
    );

    const success = response.status > 199 && response.status < 300;

    if (success) {
      yield put(
        ListaActions.getTermoResponsabilidadeMassaInicialSuccess(
          response.data,
          nomeArquivoDownload
        )
      );
    }
  } catch (error) {
    yield put(ListaActions.getTermoResponsabilidadeMassaInicialError(error));
  }
}

export function* postArquivoMassaInicial(action) {
  const { body } = action.payload;

  try {
    const response = yield retry(
      1,
      2000,
      listasMassaInicialAPI.post,
      `/massa-inicial`,
      body
    );
    const isSuccess = response.status > 199 && response.status < 299;
    const { isValid } = response.data.validationResult;

    if (isSuccess) {
      if (isValid) {
        yield put(ListaActions.postArquivoMassaInicialSuccess(response.data));
      } else {
        const [error] = response.data.validationResult.errors;
        yield put(
          ListaActions.postArquivoMassaInicialError(error.errorMessage)
        );

        toast.error(<WarningToast>{error.errorMessage}</WarningToast>);
      }
    }
  } catch (error) {
    if (error.response.status === 500)
      toast.error(<WarningToast>Erro ao importar massa incial</WarningToast>);
    else toast.error(<WarningToast>{error.errorMessage}</WarningToast>);
    yield put(ListaActions.postArquivoMassaInicialError(error.errorMessage));
  }
}

export function* patchValidacaoListaTransferencia(action) {
  const { listas } = action.payload;

  try {
    const response = yield all(
      listas.map((lista) =>
        retry(
          2,
          2000,
          listasAPI.patch,
          `${lista.idLista}/validar-transferencia`,
          { descricao: lista.descricao }
        )
      )
    );
    const isSuccess = response.every((a) => a.status > 199 && a.status < 299);
    if (isSuccess) {
      yield put(ListaActions.patchValidacaoListaTrasnferenciaSuccess([], true));
      toast.success(
        <SuccessToast size="30">
          Sucesso ao alterar o status da lista!
        </SuccessToast>
      );
      history.push('/novo/lista');
    } else
      yield put(
        ListaActions.patchValidacaoListaTrasnferenciaError(
          'Erro ao enviar para validação'
        )
      );
  } catch (error) {
    yield put(ListaActions.patchValidacaoListaTrasnferenciaError(error));
  }
}

export function* patchAceiteCompartilhamento(action) {
  const { body, idLista } = action.payload;

  try {
    const response = yield retry(
      1,
      2000,
      listasMassaInicialAPI.patch,
      `/${idLista}/aceite-compartilhamento-termo`,
      body
    );

    const success = response.status > 199 && response.status < 300;

    if (success) {
      yield put(ListaActions.patchAceiteCompartilhamentoMassaInicialSuccess());
    }
  } catch (error) {
    if (error.status && error.status === 400)
      toast.error(<WarningToast>{error.errors[0]}</WarningToast>);

    yield put(ListaActions.patchAceiteCompartilhamentoMassaInicialError(error));
  }
}

export function* postArquivoImportacaoNestle(action) {
  const { params } = action.payload;
  const arquivoNestle = {
    id: params.newFiles[0].idFile,
    arquivo: params.newFiles[0].base64,
    nomeArquivo: params.newFiles[0].name,
    idHub: params.connection.connectionId || 0,
  };

  yield put(ListaActions.importarLoteUpdate(params.newFiles[0]));

  try {
    const response = yield retry(
      1,
      2000,
      listasAPI.post,
      `/arquivo-importacao-nestle`,
      arquivoNestle
    );

    const isSuccess = yield response.status === 204 || false;
    if (isSuccess) {
      yield put(
        ListaActions.importarLoteUpdateStatus(
          params.newFiles[0].idFile,
          false,
          true
        )
      );
      yield put(ListaActions.importarLoteSuccess(isSuccess, false));
      toast.success(
        <SuccessToast size="30">
          Arquivo(s) carregado(s) com sucesso.
        </SuccessToast>
      );
    }
  } catch (error) {
    if (error.response.status === 400) {
      yield put(
        ListaActions.importarLoteLogError(
          params.newFiles[0].name,
          error.response.data && error.response.data.errors.Messages
        )
      );
    }

    toast.error(
      <ErrorToast size="30">
        Erro ao carregar o arquivo:
        <br />
        <strong>{params.newFiles[0].name}</strong>.
        {error.response.status !== 400 && (
          <>
            <br />
            {error.response.data ? error.response.data.errors.Messages : ''}.
          </>
        )}
      </ErrorToast>
    );
  }
}
